import { typographyStyles } from "@newsela/angelou";

export const containerCss = {
  border: "none",
  padding: 0,
  margin: 0,
  legend: {
    ...typographyStyles.textSObj,
    fontWeight: "bold",
  },
};

export const listCss = {
  margin: "10px 0",
};

export const checkboxCss = {
  root: {
    padding: "8px 16px",
  },
};
